import { makeStyles } from 'tss-react/mui';

const useStylesWidgetImageSlider: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  widgetImageSliderItemEdit: {
    position: 'relative',
    padding: '6px 8px',
    textAlign: 'center',
    '&:hover': {
      opacity: 0.9,
    },
  },
  widgetImageSliderItemEditImage: {
    background: theme.palette.info.light,
    '& > img': {
      maxHeight: '100px !important',
      maxWidth: '100px !important',
    },
  },
  widgetImageSliderNewItem: {
    height: 150,
  },
  widgetImageSliderNewItemPreviewImage: {
    maxWidth: '150px !important',
    maxHeight: '90px !important',
  },
  widgetImageSliderNewItemDropTargetBox: {
    width: '80px !important',
    height: '80px !important',
  },
}));

export default useStylesWidgetImageSlider;
